import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import DetailClinicComponents from "../components";
import { useQuery } from "@tanstack/react-query";
import {
  getBusinesAddress,
  getBusinesOperatingHours,
  getBusinesProfileHandler,
  getBusinesDoctor,
} from "../../../../services/Handlers/BusinessProfileService";
import { getDoctorByBusinessId } from "../../../../services/GeneralService";

export default function DetailClinic() {
  const location = useLocation();
  let { slug } = useParams();

  const [dataProfile, setDataProfile] = useState({
    id: null,
    businessName: "",
    businessAddress: "",
    businessLogo: null,
    about: "",
    yearEstablished: "",
    phoneNumber: "",
  });
  const [businessAddress, setBusinessAddress] = useState(null);
  const [operatingHours, setOperatingHours] = useState([]);
  const [doctorSchedules, setDoctorSchedules] = useState([]);
  const [dataDoctors, setDataDoctors] = useState([]);

  const { isFetching: isLoadingBusinessProfile } = useQuery(
    ["BusinessProfileHandler", slug],
    () => getBusinesProfileHandler(null, slug),
    {
      onSuccess: (res) => {
        if (res.data && res.status === 200) {
          const response = res?.data?.data;
          if (response) {
            setDataProfile((prevState) => ({
              ...prevState,
              id: response.id,
              about: response.about,
              yearEstablished: response.year_founded,
              businessName: response.business_name || prevState.businessName,
              phoneNumber: response.phone_number,
              businessLogo: response.image_url || prevState.businessLogo,
            }));
          }
        }
      },
      enabled: !!slug,
      refetchOnWindowFocus: false,
    }
  );

  const { isFetching: isLoadingAddress } = useQuery(
    ["BusinessAddress", dataProfile.id],
    () => getBusinesAddress(dataProfile.id),
    {
      enabled: !!dataProfile.id,
      onSuccess: (res) => {
        if (res.status === 200 && res.data?.data?.address) {
          const addressData = res.data.data.address;

          setBusinessAddress({
            lat: parseFloat(addressData.latitude),
            lng: parseFloat(addressData.longitude),
            address: addressData.address,
            id: addressData.id,
            busines_id: addressData.busines_id,
            has_address: addressData.has_address,
          });
        }
      },
      onError: (error) => {
        console.error("Failed to fetch business address:", error);
      },
    }
  );

  const { isLoading: isLoadingHours } = useQuery(
    ["BusinessOperatingHours", dataProfile.id],
    () => getBusinesOperatingHours(dataProfile.id),
    {
      enabled: !!dataProfile.id,
      onSuccess: (res) => {
        if (res.status === 200) {
          if (res?.data?.data) {
            setOperatingHours(res.data.data.operating_hours);
          }
        }
      },
      onError: (error) => {
        console.error("Failed to fetch operating hours:", error);
      },
    }
  );

  const { isLoading: isLoadingDoctors } = useQuery(
    ["BusinessDoctors", dataProfile.id],
    () => getBusinesDoctor(dataProfile.id),
    {
      enabled: !!dataProfile.id,
      onSuccess: (res) => {
        if (res.status === 200) {
          if (res?.data?.data?.schedules) {
            setDoctorSchedules(res.data.data.schedules);
          }
        }
      },
      onError: (error) => {
        console.error("Failed to fetch doctor schedules:", error);
      },
    }
  );

  const { isFetching: isFetchingDoctor } = useQuery(
    ["getDoctorByBusinessId", dataProfile.id],
    () => getDoctorByBusinessId(dataProfile.id),
    {
      onSuccess: (res) => {
        const response = res.data;
        if (response && response.length > 0) {
          setDataDoctors(response);
        }
      },
      enabled: !!dataProfile.id,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (window.location.pathname.split("/").includes("dashboard")) {
      window.history.pushState(
        {},
        "",
        location.pathname.replace("/dashboard", "")
      );
    }
  }, [location]);

  return (
    <DetailClinicComponents
      dataProfile={dataProfile}
      businessAddress={businessAddress}
      operatingHours={operatingHours}
      doctorSchedules={doctorSchedules}
      isLoadingBusinessProfile={isLoadingBusinessProfile}
      isLoadingAddress={isLoadingAddress}
      isLoadingHours={isLoadingHours}
      isLoadingDoctors={isLoadingDoctors || isFetchingDoctor}
      dataDoctors={dataDoctors}
    />
  );
}
